var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.582,
    height: 21.683,
    viewBox: "0 0 28.582 21.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list-interface-symbol",
    transform: "translate(0 -73.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_0_21_",
    transform: "translate(0 73.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17264",
    "data-name": "Group 17264",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8338",
    "data-name": "Path 8338",
    d: "M2.957,73.862a2.957,2.957,0,1,0,2.957,2.957A2.957,2.957,0,0,0,2.957,73.862Zm0,7.885A2.957,2.957,0,1,0,5.913,84.7,2.957,2.957,0,0,0,2.957,81.747Zm0,7.885a2.957,2.957,0,1,0,2.957,2.957A2.957,2.957,0,0,0,2.957,89.631ZM10.841,78.79H26.61a1.971,1.971,0,1,0,0-3.942H10.841a1.971,1.971,0,0,0,0,3.942ZM26.61,82.732H10.841a1.971,1.971,0,0,0,0,3.942H26.61a1.971,1.971,0,1,0,0-3.942Zm0,7.885H10.841a1.971,1.971,0,1,0,0,3.942H26.61a1.971,1.971,0,1,0,0-3.942Z",
    transform: "translate(0 -73.862)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list_view.eed10ee0d61be2eb11d98c19587452a7.svg";
export { ForwardRef as ReactComponent };